import { badgeBaseDefinition } from '../Badge/badge.common';
import styles from './TextBadge.styles.scss';
import { TextBadgeComponent } from './TextBadge';
export const textBadgeDefinition = badgeBaseDefinition('text-badge', styles);
export const chameleonTextBadge = TextBadgeComponent.compose(textBadgeDefinition);
